import { arrayPushUnique } from '../../../../core/util/array-push-unique';
import { arrayReorder } from '../../../../core/util/array-reorder';
import { Control } from '../../../../vas/business-objects/control/control.model';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

export const controlReorderReducer = (
    state = initialState,
    action: actions.ControlReorder
): State => {
    const reorderedControls = (() => {
        let controls = state.control.ids
            .map(id => state.control.entities[id])
            .filter(c => c.group === state.group.selected)
            .sort((a, b) => a.sequence - b.sequence);

        controls = arrayReorder(controls, action.payload);
        controls = controls
            .map((c, sequence) =>
                new Control({...c, sequence})
            );
        return controls;
    })();

    const result = {
        ...state.control.entities
    };
    reorderedControls.forEach(c => result[c.id] = c);

    return {
        ...state,
        dirty: true,
        dirtyIds: {
            ...state.dirtyIds,
            controls: reorderedControls.reduce(
                (acc, c) => arrayPushUnique(acc, c.id),
                state.dirtyIds.controls
            )
        },
        control: {
            ...state.control,
            entities: result
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/control-reorder.reducer.ts